/*
 *
 * LanguageProvider constants
 *
 */

export const CHANGE_LOCALE = 'app/LanguageToggle/CHANGE_LOCALE'
export const CHANGE_TENANT = 'app/LanguageToggle/CHANGE_TENANT'
